import React, { useEffect, useState } from 'react';
import { InspectionStore } from '../../contexts/InspectionContext';
import ProjectContext from '../../contexts/ProjectContext';
import projectApi from '../../utils/api/project';
import { useRouteMatch } from 'react-router-dom';
import inspectionTemplateApi from '../../utils/api/inspectionTemplate';
import AppContext from '../../contexts/AppContext';
import db, { getOfflineProjectDocs } from '../../db/db';
import { withOfflineFallback } from '../../utils/offlineFallback';
/**
 *
 */

 
const FullScreenLayout = ({ children }) => {
  const match = useRouteMatch();
  const [loadedProject, setLoadedProject] = useState(null);
  const [projectDocs, setProjectDocs] = useState();
  const [templateName, setTemplateName] = useState();
  const [isDownloaded, setIsDownloaded] = useState(false);
  const appContext= React.useContext(AppContext);

  // This layout wraps the full-screen map editor and supplies its own
  // projectDocs, so it needs its own offline fallbacks — the app-level
  // ProjectContext.loadDocs is not what runs here. Both awaits were previously
  // unguarded inside an async useEffect, so offline each rejection escaped as an
  // uncaught Network Error and projectDocs stayed undefined.
  useEffect(() => {
    const projectId = match.params.projectId;

    const loadDocs = () =>
      withOfflineFallback(
        () => projectApi.getDocs(projectId),
        () => getOfflineProjectDocs(projectId),
      );

    // projectApi.get already falls back internally; kept explicit here so a
    // failure cannot leave projectDocs/isDownloaded unresolved.
    const loadProject = () =>
      withOfflineFallback(
        () => projectApi.get(projectId),
        () => db.projects.get(Number(projectId)),
      );

    const load = async () => {
      try {
        setProjectDocs(await loadDocs());
      } catch (err) {
        console.error('FullScreen: cannot load project docs', err);
      }

      try {
        const getProject = await loadProject();

        setLoadedProject(getProject ?? null);
        setIsDownloaded(getProject && isDownloadedByLoggedInUser(getProject));

        setTemplateName(
          getProject?.project_inspection_templates?.[0]?.inspection_template
            ?.name ?? null,
        );
      } catch (err) {
        console.error('FullScreen: cannot load project', err);
        // Offline the map editor is only reachable for a downloaded project.
        setIsDownloaded(!navigator.onLine);
      }
    };

    load();
  }, []);


  const isDownloadedByLoggedInUser = (project) => {

    if(!navigator.onLine){
      return true;
    }
    
    if (project && project.offline_projects?.length) {
      const offlineProjects = project.offline_projects.filter(
        (offlineProject) => offlineProject.user_id ===  appContext.get('user').id
      );

      if (offlineProjects.length > 0) {
        return true;
      } else {
        return false;
      }
     
    }
    else {
      return true;
    }
  }

  
  return (
    <ProjectContext.Provider
      value={{
        project: loadedProject,
        projectDocs,
        setProjectDocs,
        template: templateName && templateName.name,
        isDownloaded
      }}
    >
      <InspectionStore>
        <div className='layout layout--fullscreen'>{children}</div>
      </InspectionStore>
    </ProjectContext.Provider>
  );
};

export default FullScreenLayout;